export default "__VITE_ASSET__kHMdhfa6__"